const extractSlices = (slices, variation) => {
	return slices.filter((slice) => slice.variation === variation);
};

export default extractSlices;
